import React, {
  useState,
  useMemo,
  type Dispatch,
  type SetStateAction,
} from "react";
import { useSelector } from "react-redux";

import Box from "@material-ui/core/Box";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";

import Button from "@material-ui/core/Button";

import { reportAvailableYearsSelector } from "src/store/userDataLoad/selector";
import { effectiveUserTimeZoneSelector } from "src/store/system/selector";
import { getDateTimePartsInTimeZone } from "src/utils/timezone";

import type { ReportParameters } from "../report";
import ScheduleCMappingsDialog from "../ScheduleCReport/MappingsDialog";

export interface ParametersSelectionScheduleCProps {
  parameters: ReportParameters;
  setParameters: Dispatch<SetStateAction<ReportParameters>>;
}

export function ParametersSelectionScheduleC({
  parameters,
  setParameters,
}: ParametersSelectionScheduleCProps) {
  const reportYears = useSelector(reportAvailableYearsSelector);
  const timeZone = useSelector(effectiveUserTimeZoneSelector);
  const currentYear = getDateTimePartsInTimeZone(new Date(), timeZone).year;
  const allScheduleCYears = useMemo(() => {
    if (!reportYears.length) {
      return [
        <MenuItem key={currentYear} value={"" + currentYear}>
          {currentYear}
        </MenuItem>,
      ];
    }
    return reportYears.map((year) => (
      <MenuItem key={year} value={"" + year}>
        {year}
      </MenuItem>
    ));
  }, [currentYear, reportYears]);
  const [openMappings, setOpenMappings] = useState(false);

  return (
    <>
      <Box display="flex" my={1}>
        <FormControl variant="outlined" margin="dense">
          <InputLabel id="year">Select Year</InputLabel>
          <Select
            label="Select Year"
            margin="dense"
            onChange={(e: any) => {
              setParameters((current) => ({
                ...current,
                year: e.target.value,
              }));
            }}
            value={parameters.year || currentYear}
          >
            {allScheduleCYears}
          </Select>
        </FormControl>
      </Box>
      <Typography variant="body1">
        The Schedule C is a tax form used by many small businesses to report
        their business income and expenses. You can run the schedule C for a
        given year and MRG will add your accounting information into the form
        for you. Simply print and add your personal details to the top of the
        form!
      </Typography>
      <ScheduleCMappingsDialog
        all
        open={openMappings}
        onClose={() => setOpenMappings(false)}
      />
      <Box position="absolute" right="0" bottom="0" mb="-56px">
        <Button onClick={() => setOpenMappings(true)}>View Mappings</Button>
      </Box>
    </>
  );
}
